class Korei18nPlugin {
    name = 'Korei18nPlugin';
    config = {
        rtlLanguages: ['ar'],
        availableLanguages: ['en', 'ar', 'ja', 'ko', 'zh', 'de', 'es'],//shown as list of available languages in chat window header to select
        defaultLanguage: "en",//default selection from above list
        languageStrings: {   //any additional language can be added in this object by adding the key in availableLanguages
            ar: {
                message: "رسالة...",
                connecting: "توصيل ...",
                reconnecting: "جاري إعادة الاتصال ...",
                entertosend: "اضغط على Enter للإرسال",
                endofchat: "نهاية سجل الدردشة",
                loadinghistory: "تحميل محفوظات الدردشة ..",
                sendText: "إرسال",
                closeText: "قريب",
                expandText: "وسعت",
                minimizeText: "تصغير",
                reconnectText: "أعد الاتصال",
                attachmentText: "المرفق",
                help: "يساعد",
                agent: "دردشة الوكيل",
                media: "وسائط",
                file: "ملف",
                dragAndDropFile: "اسحب الملف وأفلته هنا للتحميل",
                tapToSpeak: "اضغط على الميكروفون للتحدث",
                listenToEnd: "جارٍ الاستماع... انقر للإنهاء",
                tapToSend: "انقر للإرسال",
                typing: "الكتابة",
                menu: "قائمة طعام",
                poweredBy: "مدعوم من",
                keyboard: "لوحة المفاتيح",
                microphone: "ميكروفون",
                cancel: "يلغي",
                speakerOn: "مكبر الصوت قيد التشغيل",
                speakerOff: "مكبر الصوت معطل",
                attachments: "المرفقات",
                close: "إغلاق الدردشة",
                reconnect: "إعادة الاتصال بالدردشة",
                today: "اليوم",
                yesterday: "أمس",
                clickToCall: "الاتصال بوكيل الصوت",
                read: "مقروءة",
                delivered: "مسلّمة",
                sent: "مرسلة",
                you: "أنت",
                uploaded: "تم الرفع",
                uploadSuccess: "تم الرفع - اضغط على إرسال أو اضغط Enter للإرسال",
                uploadFailed: "فشل التحميل",
                download: "تحميل"
            },
            ja: {
                message: 'メッセージ...',
                connecting: '接続中...',
                reconnecting: '再接続中...',
                entertosend: 'Enterキーを押して送信',
                endofchat: 'チャット履歴の終わり',
                loadinghistory: 'チャット履歴を読み込んでいます...',
                sendText: '送信',
                closeText: '閉じる',
                expandText: '展開',
                minimizeText: '最小化',
                reconnectText: '再接続',
                attachmentText: '添付ファイル',
                help: 'ヘルプ',
                agent: 'エージェントチャット',
                media: 'メディア',
                file: 'ファイル',
                dragAndDropFile: 'ドラッグ＆ドロップしてファイルをアップロード',
                tapToSpeak: 'マイクをタップして話す',
                listenToEnd: '聴いています... 終了するにはタップしてください',
                tapToSend: 'タップして送信',
                typing: '入力中',
                menu: 'メニュー',
                poweredBy: 'Powered by',
                keyboard: 'キーボード',
                microphone: 'マイク',
                cancel: 'キャンセル',
                emojis: '絵文字',
                speakerOn: 'スピーカーオン',
                speakerOff: 'スピーカーオフ',
                attachments: '添付ファイル',
                close: 'チャットを閉じる',
                reconnect: 'チャットを再接続',
                today: '今日',
                yesterday: '昨日',
                clickToCall: "音声エージェントに接続",
                read: "読み込み",
                delivered: "配信",
                sent: "送信",
                you: "あなた",
                uploaded: "アップロード",
                uploadSuccess: "アップロード完了 - 送信をタップするかEnterキーを押して送信",
                uploadFailed: "アップロード失敗",
                download: "ダウンロード"
            },
            ko: {
                message: '메시지...',
                connecting: '연결 중...',
                reconnecting: '재연결 중...',
                entertosend: 'Enter 키를 눌러 전송',
                endofchat: '채팅 기록 끝',
                loadinghistory: '채팅 기록을 로딩 중입니다...',
                sendText: '전송',
                closeText: '닫기',
                expandText: '확장',
                minimizeText: '최소화',
                reconnectText: '재연결',
                attachmentText: '첨부 파일',
                help: '도움말',
                agent: '에이전트 채팅',
                media: '미디어',
                file: '파일',
                dragAndDropFile: '파일을 여기에 끌어다 놓아 업로드',
                tapToSpeak: '마이크를 탭하여 말하기',
                listenToEnd: '듣고 있습니다... 종료하려면 탭하세요',
                tapToSend: '탭하여 전송',
                typing: '입력 중',
                menu: '메뉴',
                poweredBy: 'Powered by',
                keyboard: '키보드',
                microphone: '마이크',
                cancel: '취소',
                emojis: '이모지',
                speakerOn: '스피커 켜짐',
                speakerOff: '스피커 꺼짐',
                attachments: '첨부 파일',
                close: '채팅 닫기',
                reconnect: '채팅 재연결',
                today: '오늘',
                yesterday: '어제',
                clickToCall: "음성 에이전트에 연결",
                read: "읽음",
                delivered: "배달",
                sent: "전송",
                you: "당신",
                uploaded: "업로드",
                uploadSuccess: "업로드됨 - 전송을 누르거나 Enter를 눌러 보내기",
                uploadFailed: "업로드 실패",
                download: "다운로드"
            },
            zh: {
                message: "消息...",
                connecting: "连接中...",
                reconnecting: "重新连接中...",
                entertosend: "按回车发送",
                endofchat: "聊天记录结束",
                loadinghistory: "加载聊天记录...",
                sendText: "发送",
                closeText: "关闭",
                expandText: "展开",
                minimizeText: "最小化",
                reconnectText: "重新连接",
                attachmentText: "附件",
                help: "帮助",
                agent: "代理聊天",
                media: "媒体",
                file: "文件",
                dragAndDropFile: "将文件拖放到此处以上传",
                tapToSpeak: "点击麦克风讲话",
                listenToEnd: "正在监听... 点击结束",
                tapToSend: "点击发送",
                typing: "输字中",
                menu: "菜单",
                poweredBy: "由...提供支持",
                keyboard: "键盘",
                microphone: "麦克风",
                cancel: "取消",
                emojis: "表情符号",
                speakerOn: "扬声器开启",
                speakerOff: "扬声器关闭",
                attachments: "附件",
                close: "关闭聊天",
                reconnect: "重新连接聊天",
                today: "今天",
                yesterday: "昨天",
                clickToCall: "连接到语音代理",
                read: "已读",
                delivered: "已送达",
                sent: "已发送",
                you: "你",
                uploaded: "已上传",
                uploadSuccess: "已上传 - 点击发送或按回车键发送",
                uploadFailed: "上传失败",
                download: "下载"
            },
            de: {
                message: "Nachricht...",
                connecting: "Verbindung wird hergestellt...",
                reconnecting: "Wiederverbindung wird hergestellt...",
                entertosend: "Drücke Enter zum Senden",
                endofchat: "Ende des Chatverlaufs",
                loadinghistory: "Lade Chatverlauf...",
                sendText: "Senden",
                closeText: "Schließen",
                expandText: "Erweitern",
                minimizeText: "Minimieren",
                reconnectText: "Wiederverbinden",
                attachmentText: "Anhang",
                help: "Hilfe",
                agent: "Agent-Chat",
                media: "Medien",
                file: "Datei",
                dragAndDropFile: "Datei zum Hochladen hierher ziehen und ablegen",
                tapToSpeak: "Tippe auf Mikrophon zum Sprechen",
                listenToEnd: "Höre zu... Tippe zum Beenden",
                tapToSend: "Tippe zum Senden",
                typing: "Tippen...",
                menu: "Menü",
                poweredBy: "Bereitgestellt von",
                keyboard: "Tastatur",
                microphone: "Mikrophon",
                cancel: "Abbrechen",
                emojis: "Emojis",
                speakerOn: "Lautsprecher ein",
                speakerOff: "Lautsprecher aus",
                attachments: "Anhänge",
                close: "Chat schließen",
                reconnect: "Chat wiederherstellen",
                today: "Heute",
                yesterday: "Gestern",
                clickToCall: " Mit Sprachagent verbinden",
                read: "Gelesen",
                delivered: "Geliefert",
                sent: "Gesendet",
                you: "Sie",
                uploaded: "Hochgeladen",
                uploadSuccess: "Hochgeladen – Auf Senden tippen oder Enter drücken zum Senden",
                uploadFailed: "Hochladen fehlgeschlagen",
                download: "Herunterladen"
            },
            es: {
                message: 'Mensaje...',
                connecting: 'Conectando...',
                reconnecting: 'Reconectando...',
                entertosend: 'Pulsa Intro para enviar',
                endofchat: 'Fin del historial del chat',
                loadinghistory: 'Cargando el historial del chat...',
                sendText: 'Enviar',
                closeText: 'Cerrar',
                expandText: 'Expandir',
                minimizeText: 'Minimizar',
                reconnectText: 'Reconectar',
                attachmentText: 'Archivo adjunto',
                help: 'Ayuda',
                agent: 'Chat con un agente',
                media: 'Multimedia',
                file: 'Archivo',
                dragAndDropFile: 'Arrastra y suelta el archivo aquí para subirlo',
                tapToSpeak: 'Toca el micrófono para hablar',
                listenToEnd: 'Escuchando... Toca para terminar',
                tapToSend: 'Toca para enviar',
                typing: 'Escribiendo',
                menu: 'Menú',
                poweredBy: 'Con tecnología de',
                keyboard: 'Teclado',
                microphone: 'Micrófono',
                cancel: 'Cancelar',
                emojis: 'Emojis',
                speakerOn: 'Activar altavoz',
                speakerOff: 'Desactivar altavoz',
                attachments: 'Archivos adjuntos',
                close: 'Cerrar chat',
                reconnect: 'Reconectar el chat',
                today: 'Hoy',
                yesterday: 'Ayer',
                clickToCall: 'Conectar con un agente de voz',
                read: 'Leído',
                delivered: 'Entregado',
                sent: 'Enviado',
                you: 'Tú',
                uploaded: 'subido',
                uploadSuccess: 'Subido. Toca o pulsa Intro para enviar',
                uploadFailed: 'Error al subir el archivo',
                download: 'Descargar',
                download_transcript: 'Descargar la transcripción'
            }
        }
    }
}
export default Korei18nPlugin;